// How a clinical-record form is opened. Extracted from ClinicalNotes so the one invariant that matters
// can be tested directly rather than only reachable by driving the whole section.
//
// THE INVARIANT: a NEW record starts from a CLEAN model.
//
// `currentModel` survives between form opens, so any path that opens a new record without resetting it
// inherits whatever the previous one left behind. That caused a real misattribution found in QA: after
// recording a prenatal test for a fetus, the next record added the ordinary way picked up the stale
// `pregnancyId`/`fetusId` and was labelled as that fetus's — on the MOTHER's own test. The fix is
// structural: every new-record path goes through here, so the reset cannot be forgotten by the next
// path someone adds.
//
// `openScopedRecord` is the single deliberate exception, for a record scoped to a fetus (decision 21).
export const makeRecordOpeners = ({
  setCurrentModel,
  setNoteType,
  setIsEditing,
  setNewNote,
  setIsDisabled,
  setOpenModal
}) => {
  const open = (model, type) => {
    // Reset FIRST, so a throw in a later setter cannot leave a stale scope armed.
    setCurrentModel(model);
    setIsEditing(false);
    if (type) setNoteType(type);
    setNewNote(true);
    setIsDisabled(false);
    setOpenModal(true);
  };

  return {
    // An ordinary blank record. `{}` is not decoration — it is the reset.
    openNewRecord: ({ type } = {}) => open({}, type),
    // A record deliberately scoped to a pregnancy/fetus. A missing scope must still produce a clean
    // model rather than falling through to whatever was there before.
    openScopedRecord: ({ type, scope } = {}) => open({ ...(scope || {}) }, type)
  };
};
